var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-container",attrs:{"id":"is-empty"}},[_c('Error',{attrs:{"type":_vm.type,"desc":_vm.desc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }